export type InterviewQA = {
  label?: string;
  question: string;
  answer: string[];
};

export type InterviewEntry = {
  id: string | number;
  title: string;
  role?: string;
  excerpt?: string;
  badge?: string;
  initial?: string;
  audience?: string;
  body?: string;
  qa?: InterviewQA[];
};

export const fallbackInterviews: InterviewEntry[] = [
  {
    id: 'interview-1',
    title: '入社2年目・監査担当',
    role: '未経験入社／20代男性スタッフ',
    badge: 'Interview 01',
    initial: 'A',
    audience: '20代男性スタッフ',
    excerpt: '残業の少なさと未経験からの挑戦が決め手。今は顧問先の経営相談も担っています。',
    qa: [
      {
        label: 'Q1',
        question: 'ウィズグロースに入社を決めた理由を教えてください',
        answer: [
          '未経験でも挑戦でき、残業の少なさから資格勉強との両立がイメージできたため応募しました。',
          '顧客と近い距離で経営支援ができる点にも魅力を感じました。',
        ],
      },
      {
        label: 'Q2',
        question: '現在担当している仕事内容を教えてください',
        answer: [
          '会計入力や決算書作成、給与計算、年末調整、納税予測など幅広く担当しています。',
          '最近はお客様の経営相談を受ける機会も増えています。',
        ],
      },
    ],
  },
  {
    id: 'interview-2',
    title: '新卒入社・会計スタッフ',
    role: '20代男性スタッフ',
    badge: 'Interview 02',
    initial: 'B',
    audience: '20代男性スタッフ',
    excerpt: '経営まで寄り添うサポート体制に惹かれ入社。多彩な顧問先と向き合い知識を吸収中。',
    qa: [
      {
        label: 'Q1',
        question: '入社後に驚いたことは？',
        answer: [
          'お客様の業種が非常に幅広く、毎日新しい学びがあります。',
        ],
      },
      {
        label: 'Q2',
        question: '仕事のやりがいを教えてください',
        answer: [
          '経営者の課題に直接向き合い、改善策を一緒に考えられることです。',
        ],
      },
    ],
  },
];
